import React, {memo, useEffect, useState} from 'react';
import {Configs} from '../../configs';
import './index.scss';

type Props =
    { interval?: number; disablePrefix?: boolean; }
    & React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;
export const VideoIframe = memo(function Image(props: Props) {
    const {src: source, disablePrefix} = props;
    const [src, setSrc] = useState(source);

    useEffect(() => {
        setSrc(source);
    }, [source]);

    return (
        <iframe
            src={(disablePrefix ? '' : Configs.IMAGE_PREFIX) + src}/>
    );
});
